import { atom } from 'jotai'

// Fullscreen state atom (non-persistent)
// Stores the ID of the widget/group that is currently in fullscreen
export const fullscreenGroupIdAtom = atom<string | null>(null)
